import React, { useState, useEffect } from "react";

import Header from "../Header";

import Auth from "../../Auth";

import { useSelector } from "react-redux";

import { isMobile } from "react-device-detect";

import { Player } from "@lottiefiles/react-lottie-player";


const NoteMaker = () => {

    const user = useSelector((state) => state.user.data || {}); // fallback to empty object

    const phone = user.phone;
    const email = user.email;
    const username = user.username;
    const studid = user.stud_id;

    const school = user.school;



    const token = 'hhhhh'

    const [notepicker, setNotePicker] = useState(null);

    const [title, setTitle] = useState('Title');

    const [note_text, setNoteText] = useState('Note content here.....');

    const truncate = (str, n) => {
        return str?.length > n ? str.substr(0, n - 1) + "..." : str;
    };


    return (
        <div className="bg-gray-800">

            <Auth />

            <div class="docs-header">
                <nav
                    class={
                        isMobile
                            ? "navbar navbar-expand-lg navbar-default bg-dark fixed-top py-3 shadow-none"
                            : "navbar navbar-expand-lg bg-dark fixed-top ms-0 py-3 shadow-none"
                    }
                >
                    <a class="d-flex text-lg-start text-start">
                        <div className="col-12 ms-0 ms-lg-0 mb-lg-0">
                            <a className="fs-t text-white">Note Maker | {" "}
                                <span className="badge rounded-pill fs-lg-4 fs-4 bg-back text-purple3 px-3">{school}</span></a>
                        </div>
                    </a>

                    <ul class="navbar-nav ms-lg-auto ms-6 flex-row d-none d-lg-flex">
                        <div className="ms-4 d-none d-lg-flex">
                            <button className="btn btn-purple btn-sm text-white fs-4 rounded-4 fwt">
                                <i class="bi bi-plus"></i> New Note
                            </button>
                        </div>
                    </ul>

                    <ul class="navbar-nav ms-lg-auto ms-6 flex-row d-lg-none">

                    </ul>
                </nav>
            </div>


            <div class="docs-nav-sidebar_ px-0 border-0 bg-dark">
                <div class="pt-12 d-none d-lg-block">
                    <div className="px-lg-3 px-3 input-group">
                        <span class="input-group-text bg-gray-800 border-0 text-white rounded-pill me-1" id="basic-addon2"><i class="fe fe-search "></i></span>
                        <input className="form-control form-control-md bg-gray-800 border-0 rounded-pill text-white"
                            placeholder="Search Reference" />
                    </div>

                    <div className="px-lg-3 px-3 mt-3">
                        <span className="btn btn-trans btn-sm text-gray-400 rounded-pill fw-medium ms-2">
                            All
                        </span>

                        <span className="btn btn-trans btn-sm text-gray-400 rounded-pill fw-medium ms-2">
                            Grouped
                        </span>

                        <span className="btn btn-trans btn-sm text-gray-400 rounded-pill fw-medium ms-2">
                            Favourite
                        </span>
                    </div>
                </div>
                <div class="docs-nav px-5 ms-n5">
                    <nav class="navigation navbar navbar-expand-sm">
                        <div class="collapse navbar-collapse">
                            <ul class="navbar-nav flex-column ms-3">

                                <li onClick={() => setNotePicker('hhhhh')}
                                    class={token === notepicker ? "nav-item cursor-pointer mt-3 bg-gray-800 fw-medium" :
                                        "nav-item cursor-pointer mt-3 bg-trans fw-medium"} style={{ borderRadius: "25px" }}>
                                    <div className="px-4 py-3">
                                        <div className="fs-3 fw-medium text-gray-400">
                                            {title}
                                        </div>

                                        <div className="fs-4 fw-light text-gray-400">
                                            {truncate(note_text, 35)}
                                        </div>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </nav>
                </div>
            </div>

            <div class="docs-wrapper bg-gray-800">

                <div className="container-fluid px-3 px-lg-15 ms-lg-10">
                    <div className="row py-lg-0 py-20">
                        {notepicker ?

                            <div className="pt-5 pb-20 pt-lg-12 pb-lg-20">
                                <div className="col-lg-6 mb-lg-4">
                                    <input className="form-control form-control-lg bg-dark border-0 rounded-pill text-white"
                                        placeholder="Title your note.."
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                </div>

                                <div className="col-12">
                                    <textarea class="form-control form-control-lg bg-dark border-0 text-white active"
                                        placeholder="Write note content...." rows="12" style={{ borderRadius: "35px" }}
                                        onChange={(e) => setNoteText(e.target.value)}
                                    >
                                    </textarea>
                                </div>
                            </div>
                            :

                            <div className="col-12 text-center pt-5 pb-20 pt-xl-20 pt-lg-10 pb-lg-20 ms-lg-2">

                                <Player
                                    autoplay={true}
                                    loop={true}
                                    controls={false}
                                    src="https://lottie.host/d84ce1aa-78b8-45e3-a6c1-30967a70d184/MHZCGOnYIe.json"
                                    style={{ width: isMobile ? '80%' : '35%' }}
                                ></Player>

                                <div className="mt-lg-n6 mb-lg-10 mb-xl-10">
                                    <span className="fs-3 text-white">Get Started Now! Click New Note to Make Notes.</span>
                                </div>
                            </div>

                        }
                    </div>
                </div>
            </div>

        </div>
    )
}

export default NoteMaker